import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseRichService } from './base-rich.service';



@Injectable()
export class InvoiceService extends BaseRichService {
  // private invoiceChangeSource = new Subject<string>();
  // invoiceChange = this.invoiceChangeSource.asObservable();

  addInvoice(account_id, username: string, PriceId: number, type: string, quantity: number = 1, selected?) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });
    // this.invoiceChangeSource.next('invoice count change');

    const body = {
      account_id: account_id,
      username: username,
      quantity: quantity,
      servicepriceid: null,
      extrapriceid: null,
      itempriceid: null,
      vpspriceid: null,
      selected: null
    };

    let api = '';
    if (type === 'service') {
      api = 'api/invoice/addService';
      body.servicepriceid = PriceId;
    } else if (type === 'extra') {
      api = 'api/invoice/addExtra';
      body.extrapriceid = PriceId;
    } else if (type === 'item') {
      api = 'api/invoice/addItem';
      body.itempriceid = PriceId;
      body.selected = selected;
    } else if (type === 'vps') {
      api = 'api/invoice/addVps';
      body.vpspriceid = PriceId;
    }
    return this.http.post(this.url + api, body, { headers: headers });
  }

  addVoipLineInvoice(account_id, line_id) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });
    return this.http.post(this.url + 'api/invoice/addVoipLine', { account_id, line_id }, { headers: headers });
  }

  payInvoice(id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });
    // this.invoiceChangeSource.next('invoice count change');
    const body = {
      id
    };
    return this.http.post(this.url + 'api/invoice/pay', body, { headers: headers });
  }

  payInvoices(username?) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    // this.invoiceChangeSource.next('invoice count change');
    const body = {
      username
    };


    return this.http.post(this.url + 'api/invoice/pay_all', body, { headers: headers });
  }

  changeServicePrice(invoice) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      id: invoice.id,
      service_price_id: invoice.service_price_id
    };

    return this.http.post(this.url + 'api/invoice/change_invoice', body, { headers: headers });
  }

}
